import React, { useState } from "react";
import Navigation from "../../Components/Navigation/Navigation";
import BackArrow from "../../Components/BackArrow/BackArrow";
import Search from "../../Components/Search/Search";
import modalImg from "../../Assets/Images/activities.png";
import SearchBarResults from "../../Components/Search/SearchBarResults";
import ActivitiesTable from "../../Components/Table/ActivitiesTable";
import CreateModal from "../../Components/Modals/CreateActivity";

const Activities = () => {
  // modal
  const [modalShow, setModalShow] = useState(false);
  // search
  const [search, setSearch] = useState("");
  return (
    <div>
      <Navigation />
      <div className="Activities-Main">
        <BackArrow to="/food" />
        <div className="Activities-Div">
          <h3>Activities</h3>
          <div className="search-modal">
            <Search SearchValFuc={setSearch} SearchValue={search} />
            <button
              className="create"
              variant="primary"
              onClick={() => {
                setModalShow(true);
              }}
            >
              + ADD ACTIVITIES
            </button>
          </div>
          <SearchBarResults SearchValue={search} />
        </div>
        <ActivitiesTable SearchValue={search} />
      </div>
      <CreateModal
        show={modalShow}
        onHide={() => {
          setModalShow(false);
        }}
        head="Add a new activity"
        detail="You can add the new activity here"
        placeholder="Enter activity"
        images={modalImg}
      />
    </div>
  );
};

export default Activities;
